<template>
  <div class="container">
    <div class="section p-0">
      <div class="box mt-0">
        <div class="columns">
          <div class="column is-4">
            <h1 class="title is-4">{{ $t("apis") }}</h1>
          </div>
          <div class="column is-8">
            <p class="buttons is-pulled-right">
              <button class="button is-rounded" @click="import_api">
                <span class="icon has-text-info">
                  <i class="fa fa-download"></i>
                </span>
                <span>{{ $t("import") }}</span>
              </button>
              <!-- <button class="button is-rounded" @click="create">
                <span class="icon has-text-warning">
                  <i class="fa fa-modx"></i>
                </span>
                <span>{{ $t("create report") }}</span>
              </button> -->
              <button class="button is-primary is-rounded" @click="init">
                <span class="icon">
                  <i class="fa fa-refresh"></i>
                </span>
                <span>{{ $t("refresh") }}</span>
              </button>
            </p>
          </div>
        </div>
        <div class="table-container">
          <table class="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th>{{ $t("name") }}</th>
                <th>{{ $t("options") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rpt in apis" :key="rpt.id">
                <td>
                  <span class="title is-6 is-flex">
                    <figure class="image is-32x32">
                      <img class="" :src="rpt.icon" />
                    </figure>
                    <span class="ml-2 pt-2"
                      >{{ rpt.name ? $t(rpt.name) : "" }}
                      <span class="subtitle is-6 pl-2">{{
                        rpt.version
                      }}</span></span
                    >
                  </span>
                </td>
                <td>
                  <p class="buttons">
                    <button
                      class="button is-rounded is-small"
                      @click="install_api(rpt)"
                      v-if="!rpt.exist_in_database"
                      :data-tooltip="$t('install')"
                    >
                      <span class="icon has-text-primary">
                        <i class="fa fa-bolt"></i>
                      </span>
                      <!-- <span>{{ $t("install") }}</span> -->
                    </button>
                    <button
                      class="button is-rounded is-small"
                      @click="uninstall_api(rpt)"
                      v-if="rpt.exist_in_database"
                      :data-tooltip="$t('uninstall')"
                    >
                      <span class="icon has-text-danger">
                        <i class="fa fa-unlink"></i>
                      </span>
                      <!-- <span>{{ $t("uninstall") }}</span> -->
                    </button>
                    <button
                      class="button is-rounded is-small"
                      @click="permissions(rpt)"
                      v-if="rpt.exist_in_database"
                      :data-tooltip="$t('permissions')"
                    >
                      <span class="icon has-text-warning">
                        <i class="fa fa-key"></i>
                      </span>
                      <!-- <span>{{ $t("permissions") }}</span> -->
                    </button>
                    <button
                      class="button is-rounded is-small"
                      v-if="!rpt.exist_in_database"
                      @click="remove(rpt)"
                      :data-tooltip="$t('delete')"
                    >
                      <span class="icon has-text-danger">
                        <i class="fa fa-trash"></i>
                      </span>
                    </button>
                    <button
                      class="button is-rounded is-small"
                      v-if="rpt.exist_in_database"
                      @click="rebuild(rpt)"
                      :data-tooltip="$t('rebuild endpoints')"
                    >
                      <span class="icon has-text-info">
                        <i class="fa fa-bolt"></i>
                      </span>
                    </button>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <permissions-modal ref="permissions_modal"></permissions-modal>
    <import-modal ref="import_modal"></import-modal>
  </div>
</template>

<script>
import {
  get,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import PermissionsModal from "./permissions_modal/Index.vue";
import ImportModal from "./import_modal/Index.vue";

export default {
  name: "ApiManager",
  components: { PermissionsModal, ImportModal },
  data() {
    return {
      apis: [],
    };
  },
  computed: {},
  methods: {
    init() {
      let v = this;
      get("/api/manage", {})
        .then((r) => {
          // console.log("modules", r);
          v.apis = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    install_api(rpt) {
      let v = this;
      put("/api/install", { name: rpt.name, pth: rpt.api_path })
        .then(() => {
          success_message(v.$t("api installed"));
          v.init();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    uninstall_api(rpt) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to uninstall this api?"),
        v,
        () => {
          del("/api/install", { uuid: rpt.uuid })
            .then(() => {
              success_message(v.$t("api uninstalled"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    permissions(mdle) {
      let v = this;
      // console.log("permissions", mdle);
      v.$refs.permissions_modal.show_modal(mdle.uuid);
    },
    create() {
      let v = this;
      v.$refs.create_modal.show_modal();
    },
    import_api() {
      let v = this;
      v.$refs.import_modal.show_modal();
    },
    remove(rpt) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to remove this api?"),
        v,
        () => {
          del("/api", { path: rpt.api_path })
            .then(() => {
              success_message(v.$t("api removed"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    rebuild(rpt) {
      let v = this;
      get("/api/rebuild", { uuid: rpt.uuid })
        .then(() => {
          success_message(v.$t("endpoints rebuilt"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.init();
  },
};
</script>

<style></style>
